<template>
  <div class="ad-play-list">
    <div class="ad-play-list__text" v-if="message.length < maxMessageLength">
      {{ message }}
    </div>
    <marquee v-else class="ad-play-list__text" :key="this.activeItem.getId()" scrollamount="10">
      {{ message }}
    </marquee>
  </div>
</template>
<script>

import { mapActions, mapState } from 'vuex'
import { eventBus, eventType } from '@/app/event-bus'
import * as types from '@/store/types'
import Helper from '@/utils/helper'

export default {
  name: 'AdPlayListText',
   data () {
    return {
      activeItem: null,
      timeout: null,
      interval: null,
      tmpAdPlaylist: null
    }
  },
  computed: {
    ...mapState({
      playListAdItems: state => state.playlist.adItems
    }),
    maxMessageLength () {
      return window.innerWidth > window.innerHeight ? 60 : 35
    },
    message () {
      return this.activeItem.getMessage()
    }
  },
  methods: {
    ...mapActions({
      playlistAdItemsSet: types.PLAYLIST.adItems.set
    }),
    /**
     * Если время показа закончилось, то включаем следующий элемент
     */
    setNextItemTimeout () {
      this.timeout = this.activeItem.getDurationSec()
      this.interval = setInterval(() => {
        this.timeout -= 1
        if (this.timeout <= 0) {
          this.playListAdItems.setNextIndex()
          clearInterval(this.interval)
          /**
           * Если последний элемент и во временной переменной есть плейлист, записываем новый плейлист
           */
          if (this.playListAdItems.isLastItem() && Helper.isDefined(this.tmpAdPlaylist)) {
            this.playlistAdItemsSet(this.tmpAdPlaylist)
            this.renderItems()
            this.tmpAdPlaylist = null
          } else {
            this.setActiveItem()
          }
        }
      }, 1000)
    },
    setActiveItem () {
      this.activeItem = this.playListAdItems.getActiveItem()
      if (Helper.isDefined(this.activeItem)) {
        this.setNextItemTimeout()
      }
    },
    updateAdTextItems (data) {
      /**
       * Если в плейлисте был 1 элемент, сразу записываем новый плейлист
       * Иначе записываем во временную переменную
       */
      if (this.playListAdItems.isPlaylistsOneItem()) {
        this.activeItem = null
        this.playlistAdItemsSet(data)
        this.renderItems()
      } else {
        this.tmpAdPlaylist = data
      }
    },
    renderItems () {
      /**
       * Если в плейлисте 1 элемент, то выводим его.
       * Иначе запускаем функцию показа элементов.
       */
      if (this.playListAdItems.isPlaylistsOneItem()) {
        this.activeItem = this.playListAdItems.getActiveItem()
      } else {
        this.setActiveItem()
      }
    }
  },
  beforeMount () {
    this.renderItems()
    eventBus.subscribe(eventType.updateAdTextItems, this.updateAdTextItems)
  },
  destroyed () {
    eventBus.off(eventType.updateAdTextItems, this.updateAdTextItems)
  }
}
</script>
